define('services/composer/templateService',[
    'lib/lodash4',
    'models/composer/Template',
    'services/apiCore',
    'services/localeService',
    'services/loggingService'
], function(
    _,
    Template,
    apiCore,
    localeService,
    loggingService
) {
    "use strict";

    var TemplateService = function () {
        var self = this;

        self.EVALUATIONS_SERVICE = "evaluations";

        //Endpoint helpers
        function userTemplatesEndpoint (service) {
            return "/"+service+"/templates";
        }
        function userTemplateEndpoint (service, templateId) {
            return userTemplatesEndpoint(service) + "/" + templateId;
        }

        function favoriteTemplatesEndpoint(service) {
            return "/"+service+"/favoritetemplates";
        }

        function favoriteTemplateEndpoint(service, templateId) {
            return favoriteTemplatesEndpoint(service) + "/" + templateId;
        }

        function createTemplate(templateData) {
            return new Template(templateData);
        }

        function logError(err) {
            loggingService.error(err);
            throw err;
        }

        //POST
        self.createUserTemplate = function (service, templateData) {
            var endpoint = userTemplatesEndpoint(service);
            return apiCore.v2.post(endpoint, templateData)
            .then(createTemplate)
            .catch(logError);
        };

        self.setFavoriteTemplate = function (service, templateId) {
            var endpoint = favoriteTemplatesEndpoint(service);
            return apiCore.v2.post(endpoint, {templateId: templateId})
            .catch(logError);
        };

        //GET
        self.getUserTemplates = function (service, options) {
            options = _.merge({
                locale: localeService.getAppLocale()
            }, options);
            var endpoint = userTemplatesEndpoint(service);
            return apiCore.v2.get(endpoint, options)
            .then(function (response) {
                response.entities = _.map(response.entities, createTemplate);
                return response;
            })
            .catch(logError);
        };

        self.getUserTemplate = function (service, templateId) {
            var options = {
                locale: localeService.getAppLocale()
            };
            var endpoint = userTemplateEndpoint(service, templateId);
            return apiCore.v2.get(endpoint, options).then(createTemplate)
            .catch(logError);
        };

        self.getFavoriteTemplateIds = function(service) {
            var endpoint = favoriteTemplatesEndpoint(service);
            return apiCore.v2.get(endpoint)
            .then(function(favoriteTemplateData) {
                return _.map(favoriteTemplateData, "id");
            })
            .catch(logError);
        };

        //PUT
        self.updateTemplate = function (service, templateId, templateData) {
            var endpoint = userTemplateEndpoint(service, templateId);
            return apiCore.v2.put(endpoint, templateData)
            .then(createTemplate)
            .catch(logError);
        };

        //DELETE
        self.deleteTemplate = function (service, templateId) {
            var endpoint = userTemplateEndpoint(service, templateId);
            return apiCore.v2.del(endpoint)
            .catch(logError);
        };

        self.unsetFavoriteTemplate = function (service, templateId) {
            var endpoint = favoriteTemplateEndpoint(service, templateId);
            return apiCore.v2.del(endpoint)
            .catch(logError);
        };
    };

    return new TemplateService();

});

